import React from 'react'
import styled from '@emotion/styled'
import { Input, color } from 'stylist'
import SearchableDropdown from 'components/SearchableDropdown'
import AddMoreButton from 'components/AddMoreButton'
import QualPreview from './QualPreview'

const backgroundColor = ({ active }) =>
  active ? color('pewter') : color('white')

const ToggleableButton = styled(AddMoreButton)`
  &,
  &:focus {
    color: ${({ active }) => (active ? color('white') : color('slate'))};
    background-color: ${backgroundColor};
  }

  &:hover {
    color: ${color('white')};
    background-color: ${color('slate')};
  }

  &:active {
    color: ${color('white')};
    background-color: ${color('pewter')};
  }
`

const DarkInput = styled(Input)`
  &,
  &:disabled {
    background-color: ${color('cadet')};
    border-color: ${color('pewter')};
  }
`

class QualDropdown extends React.Component {
  state = {
    opened: false // Need to sync with dropdown state so the button knows
  }

  handleToggle = opened => {
    if (this.state.opened !== opened) {
      // Only re-render when they are different
      this.setState({ opened })
    }
  }

  render() {
    const { quals, onSelect, locale } = this.props
    return (
      <SearchableDropdown
        popperOptions={{
          placement: 'bottom-start'
        }}
        trigger={(toggle, ref) => (
          <ToggleableButton
            ref={ref}
            active={this.state.opened}
            onClick={toggle}
          >
            Add Target
          </ToggleableButton>
        )}
        onToggle={this.handleToggle}
        onSelect={onSelect}
        options={Object.entries(quals)
          .sort()
          .map(([qualID, qual]) => ({
            value: qualID,
            title: qual.title,
            tooltip: (
              <QualPreview
                title={qual.text}
                contents={
                  qual.options.length ? qual.options : <DarkInput disabled />
                }
                locale={locale}
              />
            )
          }))}
      />
    )
  }
}

export default QualDropdown



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QualDropdown.js